import { ScheduleGridBodyCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";
import DepartmentProductionScheduleRightBodyCellCellEntity from "./DepartmentProductionSchedule.RightBodyCell.CellEntity";
import injectStores from "components/RootStore/injectStores";
import ServiceStore from "stores/ServiceStore";
import RootStore from "stores/RootStore";

interface EntityProps {
  id: string;
  productName: string;
  productCode: string;
  scheduleDate: string;
  departmentId: string;
  formId: string;
  formName: string;
  quantity: number;
  status: "planned" | "in_progress" | "completed" | "cancelled";
}

interface DepartmentProductionScheduleRightBodyCellProps
  extends ScheduleGridBodyCellProps {
  itemsFromEntity: unknown[];
  panelStore: ServiceStore;
  rootStore?: RootStore;
}

const DepartmentProductionScheduleRightBodyCell = injectStores(
  (props: DepartmentProductionScheduleRightBodyCellProps) => {
    // const panelStore = props.panelStore as ServiceStore;
    // Debug logging commented out - props.currentHeader and props.scheduleDate not in interface
    // if (props.rowIndex === 1 && props.columnIndex === 1) {
    //   console.log('Sample cell props (row 1, col 1):', {
    //     itemsFromEntityCount: props.itemsFromEntity?.length,
    //     itemsFromEntity: props.itemsFromEntity,
    //   });
    // }
    const backgroundColor = props.rowIndex % 2 === 0 ? "#f0f0f0" : "#e0e0e0";
    if (!props.itemsFromEntity || props.itemsFromEntity?.length === 0) {
      return (
        <div
          style={{
            ...props.style,
            // ...props.styles,
            borderLeft: "1px solid #eee",
            borderRight: "1px solid #eee",
            borderTop: "1px solid #eee",
            // borderBottom: '2px solid black',
            backgroundColor: backgroundColor,
            height: ((props?.style?.height as number) || 50) - 3,
          }}
        />
      );
    }
    const { itemsFromEntity } = props;
    return (
      <div
        style={{
          ...props.style,
          borderLeft: "1px solid #eee",
          borderRight: "1px solid #eee",
          borderTop: "1px solid #eee",
          borderBottom: "2px solid black",
          backgroundColor: backgroundColor,
          height: ((props?.style?.height as number) || 50) - 3,
          // ...props.styles,
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
          padding: "2px",
        }}
      >
        {itemsFromEntity
          .sort((a, b) =>
            (a as EntityProps).productCode.localeCompare(
              (b as EntityProps).productCode
            )
          )
          .map((currentEntity) => {
            return (
              <DepartmentProductionScheduleRightBodyCellCellEntity
                key={(currentEntity as EntityProps).id}
                entity={currentEntity as EntityProps}
                {...props}
              />
            );
          })}
      </div>
    );
  }
);

export default DepartmentProductionScheduleRightBodyCell;
